
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { WizEventManager } from '@wizeoo/akm-component-lib';

import { AlkEvent } from '../../../framework/events/alk.event';
import { ScenarioVO } from '../../../vo/scenarii/scenario.vo';
import { ALK_EVENT_TYPE } from '../../../model/enums';
import { Model } from '../../../model/model';

/**
 * rendu de la pop de confirmation
 */
@Component({
  selector: 'scen-pop-action-renderer',
  templateUrl: './scen-pop.action.renderer.html',
  styles: [':host {max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

/**
 * Renderer des actions sur un modèle de codification dans le grid
 */
export class ScenPopActionRenderer implements AgRendererComponent {
  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  scen: ScenarioVO = null;

  public get model(): Model {
    return this.scen.model;
  }

  /** delete autorisé ? */
  public canAdd(): boolean {
    let result: boolean = true;
    return result;
  }

  /** édition autoriséer ? */
  public canEdit(): boolean {
    return this.scen.userMode && this.scen.owner ===  this.model.currentUser.mail;
    // let result: boolean = true;
    // return result;
  }

  /** delete autorisé ? */
  public canDelete(): boolean {
    return this.scen.userMode && this.scen.owner ===  this.model.currentUser.mail;
    // if(this.scen.code === ViewData.wildcardMainScenario) {
    //   return false;
    // }
    // return true;
  }

  /** demande d'ajout */
  public doAdd(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.ADD, this.scen, this));
  }

  /** demande de modif */
  public doEdit(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.EDIT, this.scen, this));
  }


  /** demande de suppression */
  public doDelete(e: Event): void {
    e.stopImmediatePropagation();
    e.preventDefault();
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.DELETE, this.scen, this));
  }





  refresh(params: ICellRendererParams): boolean {
    this.scen = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.scen = params.data;
    this.cdref.markForCheck();
  }
}
